import "./App.css";
import Pricing from "./screens/Pricing/Pricing";

function App() {
  return (
    <div className="App">
      <Pricing />
      {/*  */}
    </div>
  );
}

export default App;
